export enum ANSWER_SHARE_STATUS {
  PUBLIC = 0,
  TUTOR_AND_ME = 1,
  ME = 2,
}

export enum ANSWER_SOURCE_ORIGIN {
  LESSON_PREPARATION = 'LESSON_PREPARATION',
  DAILY_STUDY = 'DAILY_STUDY',
}
